// Import required libraries
import React, { useContext } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

// Import custom components
import Nav from "../Nav/Nav";
import UserInfo from "../UserInfo/UserInfo";
import ClientLogo from "../ClientLogo/ClientLogo";
// import ThemeSelector from "../ThemeSelector/ThemeSelector";
import SigviewVR from "../Common/SigviewVR";
import ViewSelection from "../ViewSelection/ViewSelection";
import OrgSelection from "../OrgSelection/OrgSelection";
import Overlay from "../Overlay/Overlay";
import DataLagReload from "../DataLagReload/DataLagReload";
import DataLag from "../DalaLag/DataLag";
import BannerDisplay from "../BannerDisplay/BannerDisplay";
import DashboardLastSaved from "../Common/DashboardLastSaved/DashboardLastSaved";
import LanguageSelection from "../LanguageSelection/LanguageSelection.js";
import { masterTrackGaEvent } from "../../services/ga";

// Import styles
import "./Header.scss";
import SigviewSingleSelect from "../Common/SigviewSingleSelect.js";
import { updateUserScreen } from "../../redux/actions.js";
import { wrapperWs } from "../../utils/analyzeUtils";
import { Box, makeStyles } from "@material-ui/core";
import SigviewSearchField from "../Common/SigviewSearchField/SigviewSearchField.js";
import { makeSigviewStyles } from "../../utils/pivotUtils.js";
// * Import contexts
import { ThemeContext } from "../../contexts/ThemeContext";
import AnalyzeShareDialog from "../../screens/Analyze/AnalyzeDashboard/AnalyzeShareDialog.js";
import SigviewTypography from "../Common/SigviewTypography.js";
import SigviewTooltip from "../Common/SigviewTooltip.js";
function Header(props = {}) {
  const {
    user,
    standaloneWs: wsForm,
    allData = {},
    dispatch: ReduxDispatcher = () => {},
    workbooks = {},
    eventHandlers = {},
    activeWorkspace = {},
    customStyle = {},
  } = props;
  const {
    handleWorkspaceOpen: onWorkspaceOpen = () => {},
    handleWorkspaceRename: onWorkspaceRename = () => {},
    handleWorkspaceDelete: onWorkspaceDelete = () => {},
  } = eventHandlers;

  // * Define required hooks/contexts
  const { state: themeState } = useContext(ThemeContext);
  const themeColors = themeState.themes[themeState.activeTheme];
  const useStyles = makeStyles((theme) => ({
    item: {
      backgroundColor: themeColors["timeFiltersBgColor"],
      marginRight: "10px",
      padding: "0px 7px",
      boxShadow: theme.palette.misc["dsItemBoxShadow"],
      borderRadius: "5px",
    },
  }));
  // * Define requires static variables
  const classes1 = useStyles();
  const { root, leftPanel, rightPanel, itemContainer, item, itemTitle } =
    classes1;

  const location = useLocation();
  const isWorkspace = location.pathname.includes("/workspace");
  const isAlerts = location.pathname.includes("/alerts");
  const isPivot = location.pathname.includes("/pivotx");
  const isReport = location.pathname.includes("/reports");
  const isDatastory = location.pathname.includes("/datastory");
  const isOverlayAvailable = user.uiFeatureList.overlayUpdates;
  const isDataLagReloadAvailable = user.uiFeatureList.forcedRefreshToast;
  const isAutosaveOn = user.screen.workspaceAutoSaveStatus;
  const isi18nAvailable = user.uiFeatureList.i18n;
  const useSigviewStyles = makeSigviewStyles(themeColors, customStyle);
  const classes = useSigviewStyles();
  const handleWorkspaceOpen = (workbook, worksheet) => {
    onWorkspaceOpen(workbook, worksheet);
  };

  return (
    <header>
      <div className={`header-left-panel`}>
        {/* <ClientLogo />
          <Nav /> */}
        {/* <SigviewSingleSelect></SigviewSingleSelect> */}
        {workbooks.status === "success" &&
          workbooks.result.workbookList.length > 0 && (
            <>
              {workbooks.result.workbookList.map((workbook, i) => {
                const worksheetList = workbook.worksheetList || [];
                // Only render if worksheetList has items
                if (worksheetList.length === 0) return null;

                return (
                  <SigviewTooltip title="Worksheet">
                    <Box className={item}>
                      <SigviewSingleSelect
                        key={workbook._id || i}
                        value={activeWorkspace.payload.worksheet.sheetName}
                        data={worksheetList.map((sheet) => ({
                          ...sheet,
                          id: sheet.sheetName,
                          name: sheet.sheetName,
                          disabled: false,
                        }))}
                        onChange={(selectedSheetOption) => {
                          const selectedWorksheet = workbook.worksheetList.find(
                            (w) => w.sheetName === selectedSheetOption
                          );
                          handleWorkspaceOpen(workbook, selectedWorksheet);
                        }}
                        minWidth="10px"
                        width="max-content"
                        border="none"
                        fontSize="12px"
                        theme={user.theme}
                        themeColors={user.themeColors}
                      />
                    </Box>
                  </SigviewTooltip>
                );
              })}
            </>
          )}

        {(isPivot || isDatastory || isAlerts || isWorkspace || isReport) && (
          <>
            <ClientLogo />
            <SigviewVR
              style={{
                height: "24px",
              }}
            />
            <SigviewTypography
              variant="heading"
              style={{
                height: "max-content",
              }}
            >
              Sigview
            </SigviewTypography>
          </>
        )}
      </div>
      <BannerDisplay />
      <div className={`right-panel`}>
        {isAutosaveOn && (
          <>
            <DashboardLastSaved />
            <SigviewVR />
          </>
        )}
        <DataLag />
        {isDataLagReloadAvailable && <DataLagReload />}
        {/* <SigviewVR />
          <ThemeSelector /> */}
        {isOverlayAvailable && (
          <>
            <SigviewVR />
            <Overlay />
          </>
        )}
        {isi18nAvailable && (
          <>
            <SigviewVR /> <LanguageSelection />
          </>
        )}
        <SigviewVR />
        <OrgSelection />
        <SigviewVR />
        <ViewSelection />
        <SigviewVR />
        {user.reqMetadata && <UserInfo />}
      </div>
    </header>
  );
}

Header.propTypes = {
  user: PropTypes.object,
  match: PropTypes.object,
};

const mapStateToProps = (state) => ({
  user: state.user,
  allData: state.data,
  changeFlag: state.changeFlag,
  standaloneWs: state.standaloneWs,
});

export default connect(mapStateToProps)(Header);
